export enum AssetType {
  Image,
  SpriteSheet,
  MultiAtlas,
}

export const GameObjectClasses = {
  Sprite: Phaser.GameObjects.Sprite,
  Rectangle: Phaser.GameObjects.Rectangle,
  Line: Phaser.GameObjects.Line,
  Text: Phaser.GameObjects.Text,
};
